export enum InitializationState {
  PENDING = 'pending',
  INITIALIZED = 'initialized',
  FAILED = 'failed',
  INITIALIZING = 'initializing',
}
